export default {
  path: 'dining',
  name: '用餐管理',
  icon: 'GuangFuOFilled',
  component: '@/pages/dining/index',
  accessKey: '40',
};
